module.exports = __webpack_public_path__ + "img/illustration-phones.47b48a12.svg";